import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import ManageCategoryLayer from "../../../components/Admin/ManageCategoryLayer";

const ManageCategory = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <ManageCategoryLayer />
      </MasterLayout>
    </>
  );
};
export default ManageCategory